import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../shared/AuthContext';
import { resolvePostLoginDestination, DEFAULT_APP_HOME, consumePostLoginRedirect } from '../../config/routes';
import AuthShell from '../auth/AuthShell';
import PageMeta from '../seo/PageMeta';

/** Finishes session after external auth redirects (reserved for OAuth redirect flows). */
export default function AuthCallbackPage() {
  const { refreshUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await refreshUser();
        if (cancelled) return;
        const params = new URLSearchParams(window.location.search);
        const fromQuery = params.get('redirect');
        const target = resolvePostLoginDestination(
          fromQuery || consumePostLoginRedirect() || DEFAULT_APP_HOME
        );
        navigate(target, { replace: true });
      } catch {
        if (!cancelled) setError('Could not complete sign-in. Try again from the login page.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [refreshUser, navigate]);

  return (
    <>
      <PageMeta title="Signing in" description="Completing sign-in" />
      <AuthShell title="Signing you in" subtitle="One moment…">
        {error ? <div className="auth-error">{error}</div> : <div className="loading-spinner" aria-label="Loading" />}
      </AuthShell>
    </>
  );
}
